import { setContext } from '@apollo/client/link/context';
import { DOM } from '@app/utils';
import { LANGUAGES } from '@app/i18n/data/languages';
import { LABELS } from '@app/config';
import getOrSetStockXSessionId from '@app/user/utils/getOrSetStockXSessionId';

const getCountryCodeFromCookie = () =>
  DOM?.getCookie('stockx_selected_region') ||
  DOM?.getCookie('stockx_ip_region');

const authLink = setContext((request, prevContext) => {
  // Token
  const { disableAuth, headers } = prevContext;
  const token = DOM.getCookie<string>('token');
  const attachAuth = !disableAuth && !!token;

  // Language
  const langCode = DOM.getCookie<string>('language_code') || 'en';
  const { url: langLocale } = LANGUAGES[langCode];
  const [language, locale] = langLocale.split('-');
  const acceptLanguage = `${language}-${locale.toUpperCase()}`;

  // device id
  const deviceId = DOM.getCookie('stockx_device_id');
  const sessionId = getOrSetStockXSessionId();

  // Country Code
  const countryCode = getCountryCodeFromCookie();

  return {
    headers: {
      ...headers,
      'App-Platform': LABELS.APP_HUMAN_NAME,
      'App-Version': LABELS.APP_HUMAN_VERSION,
      ...(attachAuth && { authorization: `Bearer ${token}` }),
      ...(!!deviceId && { 'x-stockx-device-id': deviceId }),
      ...(!!sessionId && { 'x-stockx-session-id': sessionId }),
      'accept-language': acceptLanguage,
      ...(countryCode
        ? {
            'selected-country': countryCode,
          }
        : {}),
    },
  };
});

export default authLink;
